import {TeamMapper} from 'app/components/entities/team';
import {User, UserContract} from 'app/components/entities/user/model';

function mapProfile(c: UserContract.Profile): User.Profile {
  return {
    id: c.ID,
    email: c.Email,
    name: c.Name,
    picture: c.Picture,
    login: c.LoginType,
    agreement: c.IsAgreementConfirmed,
    homeTeam: c.UserPrivateTeam,
    role: TeamMapper.getRoleClass(TeamMapper.mapRoleType(c.CurrentRole, c.IsMaster)),
  };
}

export const UserMapper = {mapProfile};
